import React from 'react'
import {useParams} from "react-router-dom";
import InactivityLogout from '../services/InactivityLogout';
import Header from '../components/Header';
import Notes from '../components/notesSection'

export default function Customernotes() {

    const {email} = useParams();
    const getDate = new Date();

    return (
        <>
            <InactivityLogout>
            <Header searchterm={email} />
            <Notes searchterm={email} getDate={getDate} />
            </InactivityLogout>
        </>
    )
}
